import { useAxios } from '../Plugins/axios';
import { useRoute } from '../Plugins/ziggy';
export default class PlotService {
    axios;
    route;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
    }
    getAll() {
        return this.axios
            .get(this.route('api.plots.index'))
            .then((response) => response.data.data);
    }
    getAllByOrchard(orchardId) {
        return this.axios
            .get(this.route('api.plots.index', { orchard_id: orchardId }))
            .then((response) => response.data.data);
    }
    getById(id) {
        return this.axios
            .get(this.route('api.plots.show', { plot: id }))
            .then((response) => response.data.data);
    }
}
